import React from 'react';
import ReactDOM from 'react-dom/client';

// --- Yazı tipi ---------------------------------------------------------------
// latin + latin-ext birlikte: latin-ext olmadan ş/ğ/ı/İ/ç sistem yazı tipine
// düşer ve kelime ortasında font değişir.
// DİKKAT: '@fontsource/poppins/400.css' TÜM alt kümeleri (devanagari dahil)
// getirir ve pakete ~400 KB gereksiz yazı tipi ekler. Alt kümeyi açıkça
// belirterek yalnızca ihtiyacımız olanı alıyoruz.
import '@fontsource/poppins/latin-300.css';
import '@fontsource/poppins/latin-400.css';
import '@fontsource/poppins/latin-500.css';
import '@fontsource/poppins/latin-600.css';
import '@fontsource/poppins/latin-700.css';
import '@fontsource/poppins/latin-ext-300.css';
import '@fontsource/poppins/latin-ext-400.css';
import '@fontsource/poppins/latin-ext-500.css';
import '@fontsource/poppins/latin-ext-600.css';
import '@fontsource/poppins/latin-ext-700.css';

import './styles/main.scss';
import { App } from './App';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root bulunamadı — index.html bozulmuş olabilir.');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
